var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column gr-2 py-1",
      attrs: { "data-qa": "diagram_age_stacked" },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "diagram-age-stacked__bar d-flex overflow-hidden rounded bg-primary",
        },
        _vm._l(_setup.ageGroups, function (group, index) {
          return _c("div", {
            key: group.label,
            staticClass: "diagram-age-stacked__segment flex-shrink-0 min-w-0",
            style: {
              flexGrow: group.frequency,
              backgroundColor: group.color,
            },
            attrs: { "data-qa": `diagram_age_stacked_segment_${index}` },
          })
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex flex-wrap ga-2 gc-4" },
        _vm._l(_setup.ageGroups, function (group, index) {
          return _c(
            "div",
            {
              key: group.label,
              staticClass: "d-flex align-center gc-1",
              attrs: { "data-qa": `diagram_age_stacked_legend_${index}` },
            },
            [
              _c("span", {
                staticClass:
                  "diagram-age-stacked__dot rounded-circle flex-shrink-0",
                style: { backgroundColor: group.color },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "text-body-2" }, [
                _vm._v(_vm._s(group.label)),
              ]),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }